const ARQUIVO_DA_MARCA = '/timestamp.txt'
const INTERVALO_MINIMO_ENTRE_CHECAGENS = 60 * 1000

type Inscrito = (temVersaoNova: boolean) => void

let temVersaoNova = false
let checadaEm: number | null = null
let checagemEmVoo: Promise<void> | null = null
const inscritos = new Set<Inscrito>()

const lerMarcaPublicada = async () => {
  const resposta = await fetch(ARQUIVO_DA_MARCA, { cache: 'no-store' })
  if (!resposta.ok) return null

  const marca = (await resposta.text()).trim()
  return marca.length > 0 ? marca : null
}

export const verificarVersaoPublicada = (): Promise<void> => {
  if (!import.meta.env.PROD || temVersaoNova) return Promise.resolve()
  if (checagemEmVoo) return checagemEmVoo
  if (checadaEm !== null && Date.now() - checadaEm < INTERVALO_MINIMO_ENTRE_CHECAGENS) {
    return Promise.resolve()
  }

  checagemEmVoo = (async () => {
    try {
      const marca = await lerMarcaPublicada()
      if (marca === null || marca === __MARCA_DO_BUILD__) return

      temVersaoNova = true
      for (const inscrito of inscritos) inscrito(true)
    } catch {
      return
    } finally {
      checadaEm = Date.now()
      checagemEmVoo = null
    }
  })()

  return checagemEmVoo
}

export const inscreverEmVersaoNova = (inscrito: Inscrito) => {
  inscritos.add(inscrito)
  inscrito(temVersaoNova)

  return () => {
    inscritos.delete(inscrito)
  }
}
